import { apiClient } from "./client";

export type League = "BRONZE" | "SILVER" | "GOLD" | "PLATINUM" | "LEGEND";

export interface LeagueStanding {
  myLeague: League;
  myRank: number | null;
  myScore: string;
  cohortSize: number;
  weekKey: string;
  msUntilNextWeek: number;
  standings: Array<{
    rank: number;
    userId: string;
    username: string | null;
    score: string;
    isMe: boolean;
  }>;
}

export async function fetchMyLeague(): Promise<LeagueStanding> {
  const { data } = await apiClient.get<LeagueStanding>("/league/me");
  return data;
}
